var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fieldset',[_c('div',{class:[_vm.$style.inputContainer, _vm.$style.full]},[_c('InputValidator',{attrs:{"config":{
        name: _vm.attribute,
        placeholder: 'Attribute',
        type: 'text',
        validate: 'max:1024|required',
        value: _vm.listItem,
      }},on:{"InputValidatorModel":_vm.handleInputChange}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }